import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TimeElapsedModel } from '@core/models/models';
import { ScreenTitleConfigService } from '@core/services/apis/screen-title-config.service';
import { DummyService } from '@core/services/apis/dummy.service';

@Component({
  selector: 'caremoni-elapsed-time',
  templateUrl: './elapsed-time.component.html',
  styleUrls: ['./elapsed-time.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class ElapsedTimeComponent implements OnInit {
  @Input() data: TimeElapsedModel = new TimeElapsedModel();
  @Input() disabled: boolean = false;
  @Input() isDeleteVisible: boolean = false;
  @Input() placeholder: string = 'テキストを入力';
  @Output() onDeleteRow: EventEmitter<TimeElapsedModel> = new EventEmitter<TimeElapsedModel>();
  @Output() onInputFocus: EventEmitter<void> = new EventEmitter<void>();
  @Output() onInputBlur: EventEmitter<void> = new EventEmitter<void>();

  comparitionOptions = [
    { name: '含む記録', value: 'like' },
    { name: '含まない記録', value: 'not_like' },
  ];

  constructor(
    public config: DynamicDialogConfig,
    public screenTitleConfigService:ScreenTitleConfigService,
    public dummyService: DummyService,
  ) {}

  async ngOnInit(): Promise<void> {

  }

  deleteRow() {
    this.onDeleteRow.emit(this.data);
  }

  fixValue() {
    const value = Number(this.data.count);
    if (isNaN(value) || value < 1) {
      this.data.count = 1;
    }
  }

  validValue(event: KeyboardEvent) {
    if (event.key === '-') {
      event.preventDefault();
    }
  }
}
